import type { CourseSummary } from '../api/client.js';

const FALLBACK_PREFERRED_COURSE_IDS = ['12b', '10b'] as const;

export function selectAuthoringCourseKey(
  coursesOrIds: Array<CourseSummary | string>,
  requestedCourseKey?: string | null,
) {
  const courseIds = coursesOrIds.map((course) => (typeof course === 'string' ? course : course.id));
  const courseIdSet = new Set(courseIds);

  if (requestedCourseKey && courseIdSet.has(requestedCourseKey)) {
    return requestedCourseKey;
  }

  const preferredCourse = coursesOrIds.find(
    (course) => typeof course !== 'string' && course.preferredAuthoring && courseIdSet.has(course.id),
  );
  if (preferredCourse && typeof preferredCourse !== 'string') {
    return preferredCourse.id;
  }

  for (const preferredId of FALLBACK_PREFERRED_COURSE_IDS) {
    if (courseIdSet.has(preferredId)) {
      return preferredId;
    }
  }

  return courseIds[0] ?? '';
}

export function courseTitleWithKey(course: CourseSummary | undefined, courseKey: string) {
  const title = course?.title ?? courseKey;
  return courseKey ? `${title} · ${courseKey}` : title;
}
